import React from 'react';
import { Text } from 'components';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import {
  ILoadingAttachments,
  ISharedAttachment,
} from 'hooks/contextualChat/useMediaAttachments';
import { Loading } from '@app/react-common';

export interface IPhotosTab {
  photos?: Array<ISharedAttachment>;
  loading?: ILoadingAttachments;
}

const PhotosTab = ({ photos, loading }: IPhotosTab) => (
    <>
      {!photos.length ? (
        <Text style={{ textAlign: 'center', marginTop: 12 }}>
          No photos or videos shared yet
        </Text>
      ) : (
        <>
          <Row style={{ marginTop: 12 }} gutter={[3, 3]}>
            {photos.map((photo, idx) => (
              <Col key={`photo-${photo}-${idx}`} span={8}>
                <a href={photo?.image} target="_blank" rel="noreferrer">
                  <StyledImg src={photo?.image} alt={`photo-${photo}-${idx}`} />
                </a>
              </Col>
            ))}
          </Row>
          {loading.query && <Loading />}
        </>
      )}
    </>
  );

const StyledImg = styled.img`
  width: 100%;
  height: 100px;
  object-fit: cover;
  display: block;
  border-radius: 2px;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(0.95);
  }
`;

export default PhotosTab;
